<div class="row" *ngIf="!isReadOnly">
  <div class="col-12 input-group">
    <ng-select class="form-control input-group-select" [items]="availableAttributes" [(ngModel)]="selectedAttribute"
      [clearable]="true" bindLabel="DisplayName" placeholder="Select Attribute"></ng-select>
    <button class="input-group-btn btn btn-primary" (click)="addAttribute()">Add</button>
  </div>
</div>

<div>
  <ng-container *ngFor="let attr of profileAttributes.controls">
    <span [ngClass]="{ 'bg-primary': attr === editedAttribute,
        'bg-secondary': attr !== editedAttribute && attr.status === 'VALID',
      'bg-danger': attr !== editedAttribute && attr.status === 'INVALID'}" class="badge attribute bg-secondary"
      (click)="editAttribute(attr)">
      {{ attr.value.DisplayName }}
      <i class="fa fa-times no-right-margin remove-attribute" (click)="removeAttribute(attr)"></i>
    </span>
  </ng-container>
</div>
<ng-container [formGroup]="profileAttributes">
  <div *ngFor="let attr of profileAttributes.controls; let i = index;" [formGroupName]="i"
    [hidden]="attr !== editedAttribute">
    <label>{{ attr.value.Display }}</label>
    <ng-container [ngSwitch]="attr.value.ValueType">
      <div *ngSwitchCase="attributeValueType.Boolean">
        <div class="input-group">
          <span class="input-group-text">{{ attr.value.DisplayName }}</span>
          <span class="input-group-btn btn btn-secondary" disabled><i class="fa fa-check 2x no-right-margin"></i></span>
        </div>
      </div>
      <div *ngSwitchCase="attributeValueType.Url">
        <div class="input-group">
          <span class="input-group-text">{{ attr.value.DisplayName }}</span>
          <input [formValidation]="attr.controls.Value" [disabled]="isReadOnly" [readonly]="isReadOnly" type="text"
            formControlName="Value" class="form-control" placeholder="https://www.example.com" />
        </div>
      </div>
      <div *ngSwitchCase="attributeValueType.Enum">
        <div class="input-group">
          <span class="input-group-text">{{ attr.value.DisplayName }}</span>
          <ng-select class="form-control input-group-select" [formValidation]="attr.controls.Value" formControlName="Value" [items]="attr.value.ValueMetadata"
            [clearable]="true" bindLabel="DisplayName" bindValue="Value" [closeOnSelect]="false"
            [readonly]="isReadOnly">
          </ng-select>
        </div>
      </div>
      <div *ngSwitchCase="attributeValueType.RepeatedEnum">
        <div class="input-group">
          <span class="input-group-text">{{ attr.value.DisplayName }}</span>
          <ng-select class="form-control input-group-select" [formValidation]="attr.controls.SelectedEnums" formControlName="SelectedEnums"
            [items]="attr.value.ValueMetadata" [clearable]="true" [multiple]="true" bindLabel="DisplayName"
            bindValue="Value" [closeOnSelect]="false" [readonly]="isReadOnly" (change)="setRepeatedEnumValue(attr, $event)"></ng-select>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>